import { loginRequest } from "../config/authConfig";
import {useMsal} from "@azure/msal-react";
import * as React from 'react';
import Logo from "../components/Logo";

function LoginPage(): React.ReactElement {
    const { instance } = useMsal();

    const handleLogin = () => {
        async function msalLogin() {
            await instance.loginRedirect(loginRequest());
        }
        msalLogin();
    };

    return (
        <div className="login-screen">
            <Logo blue/>
            <button onClick={handleLogin}>
                Mit Microsoft Anmelden
            </button>
        </div>
    );
}

export default LoginPage;